import React, { useState } from 'react';
import { Button, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { DataGrid } from "@mui/x-data-grid";
import { getAuth } from "firebase/auth";
import callApi from "../common/APIClient"

function NER() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [isNER, setIsNER] = useState(false);
  const [nerStatus, setNERStatus] = useState('');
  const columns = [{ field: "word", headerName: "Word", width: 200 }, 
                   { field: "entity_group", headerName: "Entity Group", width: 200 }, 
                   { field: "score", headerName: "Score", width: 150 }];
  const [rows, setRows] = useState('');

  // Handle file selection,
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  //const [entities, setEntities] = useState([]);
  //const [scores, setScores] = useState([]);

  // Handle file upload to REST API
  const handleFileUpload = async () => {
    if (!selectedFile) {
      alert('Please select a file before extracting keys.');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);

    setIsNER(true);
    setNERStatus('Extracting Keys...');

    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) return;
      const token = await user.getIdToken();

      const response = await callApi({
        url: "/ner/",
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      
      setNERStatus('NER successful!');

      const entities = response;
      console.log('Entities: ', entities);
      const rowsWithId = entities.map((entity, index) => ({ id: index, ...entity }));
      setRows(rowsWithId);
      console.log('Server Response:', response);
    } catch (error) {
      setNERStatus('NER failed.');
      console.error('NER error:', error);
    } finally {
      setIsNER(false);
    }
  };

  return (
    <Grid container spacing={2}>
        <Grid size={12}>
            <Typography variant="h6">Extract Key Information Using AI</Typography>
        </Grid>
        <Grid size={4}>
            {/* File input */}
            <Button variant="contained" component="label">
                Choose File
                <input type="file" hidden onChange={handleFileChange} />
            </Button>
        </Grid>
        <Grid size={8}>
            {selectedFile && (
                <Typography variant="body2" sx={{ marginTop: 2 }}>
                Selected file: {selectedFile.name}
                </Typography>
            )}
        </Grid>
        <Grid size={4}>
            {/* Upload Button */}
            <Button
                variant="contained"
                color="primary"
                onClick={handleFileUpload}
                disabled={isNER || !selectedFile}
                sx={{ marginTop: 2 }}
            >
                Run NER
            </Button>
        </Grid>
        <Grid size={8}>
            {/* Upload Status */}
            {nerStatus && (
                <Typography variant="body2" sx={{ marginTop: 2 }}>
                {nerStatus}
                </Typography>
            )}
        </Grid> 
        <Grid size={12}>
            {/* Scores */}
            {nerStatus && (
                <Typography variant="body2" sx={{ marginTop: 2 }}>
                <div className="p-4">
                  <h2 className="text-xl font-bold mb-2">Key-Value Pairs</h2>
                  <DataGrid rows={rows} columns={columns} pageSize={5} />
                </div>
                </Typography>
            )}
        </Grid>       
    </Grid>
  );
}

export default NER;
